import image from "../../assets/GalleryImages/Strijp.JPG";
import Image1 from "../../assets/GalleryImages/Table1.JPG";
import Image2 from "../../assets/GalleryImages/Train.JPG";
import Image3 from "../../assets/GalleryImages/Table3.JPG";
import { N1_THREE_QUARTER as Image4 } from "../N1/images";
import Image5 from "../../assets/GalleryImages/Image1-2.JPG";

const preloadImages = [image, Image1, Image2, Image3, Image4, Image5];

export default preloadImages;
